import * as _ from 'lodash';
import { TenantIntegration } from './tenantIntegration';
import { TenantPlan } from './tenantPlan';
import { TenantModule } from './tenantModule';
import { AdminPortalModel } from 'src/app/admin/admin-home/admin-portal/admin-portal-model';

export class Tenant {
  public id: string;
  public name: string;
  public defaultConnection: string;
  public baseWebUrl: string;
  public connections: string[];
  public logoUrl: string;
  public administrator: string;
  public administratorEmail: string;
  public bccAdministrator: boolean;
  public fromEmail: string;
  public manageRolesInLineup: boolean;
  public integrations: TenantIntegration[];
  public modules: TenantModule[];
  public plan: TenantPlan;
  public timeZone: string;
  public tenantHelpLink: string;
  public allowPortalUserCreation: boolean;
  public portalConfiguration: AdminPortalModel;
  constructor(
    id: string,
    name: string,
    defaultConnection: string,
    baseWebUrl: string,
    connections: string[],
    logoUrl: string,
    administrator: string,
    administratorEmail: string,
    bccAdministrator: boolean,
    fromEmail: string,
    manageRolesInLineup: boolean,
    integrations: TenantIntegration[],
    modules: TenantModule[],
    plan: TenantPlan,
    timeZone: string,
    tenantHelpLink: string,
    allowPortalUserCreation: boolean = false,
    portalConfiguration: AdminPortalModel
  ) {
    this.id = id;
    this.name = name;
    this.defaultConnection = defaultConnection;
    this.baseWebUrl = baseWebUrl;
    this.connections = connections;
    this.logoUrl = logoUrl;
    this.administrator = administrator;
    this.administratorEmail = administratorEmail;
    this.bccAdministrator = bccAdministrator;
    this.fromEmail = fromEmail;
    this.manageRolesInLineup = manageRolesInLineup;
    this.integrations = integrations;
    this.modules = modules;
    this.plan = plan;
    this.timeZone = timeZone;
    this.tenantHelpLink = tenantHelpLink;
    this.allowPortalUserCreation = allowPortalUserCreation;
    this.portalConfiguration = portalConfiguration;
  }

  get usesCertifications(): boolean {
    return _.some(this.integrations, (tenantIntgegration) => {
      return tenantIntgegration.providesCertifications;
    });
  }

  static parse(obj: any): Tenant {
    if (!obj) return;
    let integrations = _.map(obj.integrations, function (integration) {
      return TenantIntegration.parse(integration);
    });

    return new Tenant(
      obj.id,
      obj.name,
      obj.defaultConnection,
      obj.baseWebUrl,
      obj.connections,
      obj.logoUrl,
      obj.administrator,
      obj.administratorEmail,
      obj.bccAdministrator,
      obj.fromEmail,
      obj.manageRolesInLineup,
      integrations,
      obj.tenantModules,
      obj.plan ? new TenantPlan(obj.plan) : null,
      obj.timeZone,
      obj.tenantHelpLink,
      obj.allowPortalUserCreation,
      obj.portalConfiguration
    );
  }
}
